// @flow
/* -----------------Globals--------------- */
import moment from 'moment';

const getTimeTakenInSeconds = (startTime?: ?string, endTime?: ?string): number => {
  const start = startTime ? Date.parse(startTime) : new Date();
  const end = endTime ? Date.parse(endTime) : new Date();
  return (end - start) / 1000.0;
};
const formatDate = (date: string) => `${moment(Date.parse(date)).format('MMMM DD, YYYY')}`;

export {
  formatDate,
  getTimeTakenInSeconds,
};
